const { FeatureSessionStoreModule } = await import("uidispatcher_api/UidispatcherApiModule");
export const Features = FeatureSessionStoreModule.Features;
export const initFeatureSessionStoreWithFeatures = FeatureSessionStoreModule.initFeatureSessionStoreWithFeatures;
export const FeatureActions = FeatureSessionStoreModule.FeatureActions;
export default FeatureSessionStoreModule.default;
